/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type DetailsSettingsType from '@jira/spa-apps__project-settings-details/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyDetailsSettings: LazyComponent<React.ComponentType<{}>> = lazyForPaint<
	typeof DetailsSettingsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-details", jiraSpaEntry: "async-project-settings-details" */ '@jira/spa-apps__project-settings-details/src/index.tsx'
		),
	),
);

const AsyncDetailsSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyDetailsSettings}
		pageId="project-settings-details"
		shouldShowSpinner={false}
	/>
);

export default AsyncDetailsSettings;
